import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BitterButton from "./BitterButton";
import UserOverlay from "./UserOverlay";
import ContactFormOver from "./ContactFormOver";
import BookingModal from "./BookingModal";
import ModalWrapper from "./utils/ModalWrapper";

const BitterButtonParent = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Handle scrolling to hash on location change
  useEffect(() => {
    if (location.hash) {
      // Remove the # from the hash
      const elementId = location.hash.substring(1);

      // Function to try scrolling to the element
      const scrollToElement = (attempts = 0) => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (attempts < 10) {
          // If element not found and we haven't tried 10 times yet, try again
          setTimeout(() => scrollToElement(attempts + 1), 100);
        }
      };

      // Start trying to scroll after a short delay
      setTimeout(() => scrollToElement(), 100);
    }
  }, [location]);

  const handleOverlayToggle = () => {
    setIsOverlayOpen(!isOverlayOpen);
  };

  // Handle Quick Actions from Radial Menu
  const handleQuickAction = (action) => {
    switch (action) {
      case "home":
        navigate("/");
        break;
      case "about":
        navigate("/about");
        break;
      case "cv":
        // Navigate to About page and scroll to top
        navigate("/about");
        // Scroll to top after navigation
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
        break;
      case "skills":
        // Navigate to About page with hash to kompass section
        navigate("/about#kompass");
        break;
      case "projects":
        // Navigate to About page with hash to references section
        navigate("/about#referenzen");
        break;
      case "email":
        // Open Contact Form Modal
        setShowContactModal(true);
        break;
      case "tel":
        // Open phone link1
        window.location.href = "tel:+4915153231791"; // Replace with actual phone number
        break;
      case "teams":
        // Open Booking Modal for scheduling appointment
        setShowBookingModal(true);
        break;
      case "lernstudio":
        // Navigate to LernStudio MediaBlog
        navigate("/lernstudio");
        break;
      case "saghallo":
        // Navigate to Contact page
        navigate("/contact");
        break;
      case "login":
        // Navigate to Login page
        navigate("/login");
        break;
      case "youtube":
        // Navigate to LernStudio YouTube tab
        navigate("/lernstudio?tab=youtube");
        break;
      case "blog":
        // Navigate to LernStudio Blog tab
        navigate("/lernstudio?tab=blog");
        break;
      case "zendev":
        // Navigate to LernStudio ZenDev tab
        navigate("/lernstudio?tab=zendev");
        break;
      case "CaseStudy":
        // Navigate to LernStudio CaseStudy tab
        navigate("/lernstudio?tab=CaseStudy");
        break;
      case "Kurse":
        // Navigate to LernStudio Kurse tab
        navigate("/lernstudio?tab=Kurse");
        break;
      default:
        break;
    }
  };

  return (
    <>
      {/* Bitter Button with Radial Menu */}
      <BitterButton
        onClick={handleOverlayToggle}
        onQuickAction={handleQuickAction}
      />

      {/* Full User Overlay */}
      {isOverlayOpen && <UserOverlay onClose={() => setIsOverlayOpen(false)} />}

      {/* Contact Modal from Quick Action */}
      {showContactModal && (
        <ModalWrapper onClose={() => setShowContactModal(false)}>
          <ContactFormOver onSuccess={() => setShowContactModal(false)} />
        </ModalWrapper>
      )}

      {/* Booking Modal for Appointment Scheduling */}
      {showBookingModal && (
        <BookingModal onClose={() => setShowBookingModal(false)} />
      )}
    </>
  );
};

export default BitterButtonParent;